export default "__VITE_ASSET__yGHZ_ChI__"